<template>
  <div>
     <md-dialog @md-clicked-outside="close" :md-active.sync="showInfo" id="campaign-track-dialog">
      <md-dialog-title style="padding-right:10px">
        <div style="width:70%;padding-top:20px">
          <div class="title-from">{{Info.campaign_title}}</div>
        </div>
        <div style="width:30%;text-align: -webkit-right;padding-top:10px;">
           <md-button class="md-icon-button" @click="close">  
              <md-icon style="color:black">close</md-icon>
            </md-button>
        </div>
      </md-dialog-title>
      <md-dialog-content style="flex-basis: inherit;">
        <md-tabs :md-active-tab="0">

          <md-tab id="tab-infomation" md-label="Infomation">
            <!-- <div style="padding-right:16px;padding-left:16px;"> -->
              <md-card class="main-content mh-15">
                <md-card-header>Basic Info</md-card-header>
                <md-card-content style="width:100%;display: -webkit-box;">
                    <div style="width:5%;padding-left:10px;padding-top:0.5%">
                      <div class="mktops-square-blue">
                          <md-icon>show_chart</md-icon>
                        </div>
                    </div>
                    <div style="width:95%">
                        <div class="table-blog">
                          <div class="head-table" style="margin-bottom:0px;color:#3b62c1;;font-weight:400">
                            <div class="col" style="width:20%">Campaign Code</div>
                            <div class="col" style="width:30%">Campaign Title</div>
                            <div class="col" style="width:50%">Campaign Detail</div>
                          </div>
                          <div class="body-table">
                            <div class="row-table">
                              <div class="col top-line desc" style="width:20%;padding-top:3px;">{{ Info.campaign_code}}</div>
                              <div class="col top-line desc" style="width:30%;padding-top:3px">{{ Info.campaign_title }}</div>
                              <div class="col top-line desc" style="width:50%;padding-top:3px">{{ Info.campaign_detail}}</div>
                            </div>
                          </div> 
                          <div class="head-table" style="margin-bottom:0px;color:#3b62c1;font-weight:400">
                            <div class="col" style="width:20%">Start Date</div>
                            <div class="col" style="width:30%">End Date</div>
                            <div class="col" style="width:50%">Join Within</div>
                          </div>
                          <div class="body-table">
                            <div class="row-table">
                              <div class="col top-line" style="width:20%;padding-top:3px">{{ convertDate(Info.startdate)}}</div>
                              <div class="col top-line" style="width:30%;padding-top:3px">{{ convertDate(Info.enddate) }}</div>
                              <div class="col top-line" style="width:50%;padding-top:3px">{{ Info.join_within}}&nbsp; days</div>
                            </div>
                          </div>
                        </div>
                        
                    </div>
                </md-card-content>
              </md-card>

              <md-card class="main-content mh-15" style="margin-top:12px;padding-bottom:5px;" v-if="Info.products.length > 0">
                <md-card-header>Selected Products</md-card-header>
                <md-card-content style="padding-left:0px;padding-top:12px">
                  <div style="width:100%;display: -webkit-box;">
                      <div class="table-blog">
                        <div class="head-table">
                          <div class="col" style="width:10%">Code</div>
                          <div class="col" style="width:50%">Description</div>
                          <div class="col" style="width:10%;text-align:right">Stock</div>
                          <div class="col pl-20" style="width:10%;">Unit</div>
                          <div class="col" style="width:10%;text-align:right">Cost</div>
                          <div class="col" style="width:10%;text-align:right">Price</div>
                        </div>
                        <div class="body-table">
                          <div class="row-table hover" v-for="(item , index) in Info.products" :key="'blog-products-'+index">
                            <div class="col top-line" style="width:10%;padding-top:3px">{{ item.code}}</div>
                            <div class="col top-line desc" style="width:50%;padding-top:3px">{{ item.title_th }}</div>
                            <div class="col top-line" style="width:10%;padding-top:3px;text-align:right">-</div>
                            <div class="col top-line desc pl-20" style="width:10%;padding-top:3px;">{{ item.selling_um_title }}</div>
                            <div class="col top-line" style="width:10%;padding-top:3px;text-align:right">{{ item.cost }}</div>
                            <div class="col top-line" style="width:10%;padding-top:3px;text-align:right">{{ checkFeild('price' , item) }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                </md-card-content>
              </md-card>

              <md-card class="main-content mh-15" style="margin-top:12px;">
                <md-card-header>Condition Sets</md-card-header>
                <md-card-content style="padding-left:0px;">
                  <md-tabs md-active-tab="tab-0">
                      <md-tab 
                      class="picture-card-md-tab"
                        v-for="(item , index) in Info.sets"
                        :key="index"
                        :id="`tab-${index}`"
                        :md-label="item.name"
                      >
                      <div style="width:100%;display: -webkit-box;">
                        <div style="width:50%;padding-left:20px;border-right: 1px solid rgba(0, 0, 0, 0.2);">
                          <div style="margin-bottom:2px;"><b>Set</b></div>
                          <div class="mb-10" style="font-family:kanit;word-wrap: break-word;font-size:15px;font-weight:300">{{item.name}}</div>
                          <div style="margin-bottom:2px;" class="pl-20"><b>Conditions</b></div>
                          <div class="mb-10 pl-20">
                            <span style="color:#3b62c1;font-weight:400">Point</span>
                            <span style="margin-left:40px">{{checkFeild('point' , item)}}</span>
                          </div>
                          <div style=";margin-bottom:5px;" class="pl-20" v-if="item.rewards.length > 0"><b>Reward</b></div>
                          <div style=";margin-bottom:2px;" class="pl-20">
                              <div class="picture-card"  :key="'picture-card-'+index_rewards"
                                  v-for="(data,index_rewards) in item.rewards">
                                <md-card class="main-content" style="margin-bottom:12px;box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.">
                                  <md-card-content style="padding-left:0px;padding-top:12px">
                                    <div style="width:100%;display: -webkit-box;">
                                        <div style="width:50%;padding-left:20px">
                                          <img class="product-image" :src="data.image">
                                        </div>
                                        <div style="width:50%;text-align: -webkit-right;">
                                          <div class="product-image-title">Product Name</div>
                                          <div class="mb-10 desc">{{data.name}}</div>
                                          <div class="product-image-title">Estimate Cost</div>
                                          <div class="mb-10">{{data.qty}}</div>
                                          <div class="product-image-title" v-if="data.sendDate">Send Date</div>
                                          <div class="mb-10" v-if="data.sendDate">{{convertDate(data.sendDate)}}</div>
                                        </div>
                                      </div>
                                  </md-card-content>
                                </md-card>
                                </div>
                          </div>
                        </div>
                        <div style="width:50%;padding-left:30px">
                          <div class="mb-10"><b>Customer Groups</b></div>
                            <div class="filter-chips">
                              <md-chip
                                style="display: inline-grid;margin-left: 0px;width:100%;margin-bottom: 3px;"
                                class="md-primary"
                                v-for="(customer,index_customer) in item.customers"
                                :key="`customer_${index_customer}`"
                              >({{index_customer+1}}) {{customer.group_name}}</md-chip>
                          </div>
                        </div>
                      </div> 
                      </md-tab>
                    </md-tabs>
                </md-card-content>
              </md-card>
            <!-- </div> -->

          </md-tab>

          <md-tab id="tab-joined" md-label="Joined">
            <!-- <div style="padding-right:16px;padding-left:16px;"> -->
              <div class="table-blog" style="padding-top:10px" v-if="Info.customers.length > 0">
                <div class="head-table" style="padding-left:10px">
                  <div class="col">Customer Name</div>
                </div>
                <div class="body-table">
                  <div class="row-table hover" style="padding-left:10px" v-for="(item , index) in Info.customers" :key="'tab-joine-'+index">
                    <div class="col top-line desc">{{ item.cust_name }}</div>
                  </div>
                </div>
              </div>
            <!-- </div> -->
          </md-tab>
          
          <md-tab id="tab-redeems" md-label="Redeems">
             <!-- <div style="padding-right:16px;padding-left:16px;"> -->
              <div class="table-blog" style="padding-top:10px" v-if="Info.customers.length > 0">
                <div class="head-table" style="padding-left:10px">
                  <div class="col" style="width :80%">Customer Name</div>
                  <div class="col" style="width :20%;text-align:right">Reward</div>
                </div>
                <div class="body-table">
                  <div class="row-table hover" style="padding-left:10px" v-for="(item , index) in Info.customers" :key="'tab-redeems-'+index">
                    <div class="col top-line desc" style="width :80%;">{{ item.cust_name }}</div>
                    <div class="col top-line" style="width :20%;text-align:right">{{ checkFeild('redeem' , item) }}</div>
                  </div>
                </div>
              </div>
            <!-- </div> -->
          </md-tab>

        </md-tabs>
    </md-dialog-content>
    <md-dialog-actions>
       <md-button class="" @click="close" style="color: #727272;">
          <b>Close</b>
        </md-button>
    </md-dialog-actions>
    </md-dialog>

  </div>
</template>
<script>
// import router from "@/router";
import moment from "moment-timezone";
export default {
  name: "campaign-info",
  props: ["dataCampaign", "showDetail"],
  computed: {
    Info() {
      return this.dataCampaign;
    }
  },
  data() {
    return {
      showInfo: true
    };
  },
  created() {
    // this.renderMonths("create");
  },
  methods: {
    checkFeild(feild , row){
      if(feild == 'price'){
        if(typeof row.price != 'undefined' && row.price != null){
          return parseFloat(row.price)
                .toFixed(2)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }else {
          return '';
        }
      }else if(feild == 'point'){
        if(typeof row.point.end != 'undefined' && row.point.end != null){
          return parseFloat(row.point.end)
                .toFixed(0)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }else{
          return '-';
        }
      }else if(feild == 'redeem'){
        if(typeof row.numOfRedeem != 'undefined' && row.numOfRedeem != null){
          return parseFloat(row.numOfRedeem)
                .toFixed(0)
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }else{
          return '-';
        }
      }else{
        return '';
      }
    },
    close(){
      this.$emit("close");
    },
    goStep(step) {
      // router.replace('/promotion/create')
      // this.$store.commit('pmcreate/setPromotion',this.promotion)
      // this.$store.commit('pmcreate/setStep', step)
    },
    convertDate(date) {
      return moment(new Date(date)).format("MMM D, YYYY");
    },
    selectedCondition(promo, cond) {
      // let value = {row: promo };
      // if (cond.name == "Delete") {
      //   this.$store.dispatch("pmmanage/deletePromo", value)
      // } else if (cond.name == "Duplicate") {
      //   this.$store.dispatch("pmmanage/duplicatePromo", value)
      // } else if (cond.name == "Track") {
      //   this.$store.dispatch("pmmanage/trackPromo", value)
      // }
    }
  }
};
</script>

<style lang="scss">
$color-primary: #3f51b5;
$color-accent: red;
$color-grey: #a8a8a8;
$color-lightgrey: #fafafa;
$color-increase-sales: #52b6b0;
$color-increase-outlets: #5daaec;
$color-new-product: #527de5;
$color-compete: #9a67e3;

$font-Lato: Lato;
$font-Roboto: Roboto;
$font-proxima: Proxima Nova;
$size-brandname: 16px;
$size-menu: 16px;

#campaign-track-dialog {
  width: 75%;
  height: 90%;
  transform: unset !important;
  top: 10% !important;
  left: 15% !important;
  .md-dialog-container {
      width: 100%;
  }

  .pl-20 {
    padding-left:20px;
  }
  .mb-10 {
   margin-bottom:10px;
  }

  .md-dialog-title {
      margin-bottom : 0px;
      padding: 30px 30px 0px 30px;
      width:100%;
      display: -webkit-box;
      padding-top:10px;
      .title-from {
        font-family: kanit;
        font-size: 18px;
        font-weight: 700;
        font-family:kanit;
        line-height: 0.8;
      }
  }
  .md-dialog-content {
    padding: 5px 5px 0px 5px;
    .table-blog {
      width:100%;
      padding-left:5px;
      padding-right:5px;
      .col {
        padding-right:10px;
      }
      .head-table {
        margin-bottom : 20px;
        display :-webkit-box; 
        font-size : 13px;
        font-family : lato; 
        font-weight:bold;
        padding-left:25px;
        padding-right:25px;
      }
      .body-table {
        overflow-y:scroll;
        overflow-x:hidden;
        .row-table {
          padding-left:25px;
          padding-right:20px;
          display :-webkit-box; 
          font-family: lato;
          font-size : 13px;
          margin-bottom: 5px;
          .top-line {
            padding-top:7px;
            padding-bottom:7px;
          }
        }
        .desc {
          font-size:14px;
          font-family:kanit;
          word-wrap: break-word;
        }
        .row-table.hover:hover{
          background: rgba(236, 236, 235, 1);
          cursor: pointer;
          border-radius:3px;
        }
      }
      .body-table::-webkit-scrollbar {
        height: 7px;
        width: 5px;
      }
    }
    .footer-table {
      display: block;
      text-align: center;
      margin-top: 5px;
      padding-bottom: 15px;
      width: 99.6%;
      font-size: 14px;
      font-style: italic;
    }
    .mktops-square-blue {
      width: 30px;
      height: 30px;
      background-color: #3B62C1;
      border-radius: 4px;
      line-height: 30px;
      text-align: center;
      font-size: 10px;
      margin-top: 8px;
      .md-icon {
        color: white;
      }
    }
    .main-content{
      box-shadow: 1px 1px 6px 2px rgba(0, 0, 0, 0.1);
      .md-card-header {
        font-family : roboto;
        font-size : 14px;
        padding-bottom:5px;
        padding-top:15px;
      }
      .md-card-content {
        padding-left:30px;
        padding-right:20px;
        padding-bottom:0px;
      }
      .picture-card {
        padding-right:40px;
        width:90%;
        .product-image {
          font-family:lato;
          width: 150px;
          height: 150px;
          background: #ccc;
          border-radius: 3px;
        }
        .product-image-title {
          font-size: 12px;
          color: #949496;
          font-family:lato;
        }
        .desc {
          font-size:14px;
          font-family:kanit;
          word-wrap: break-word;
        }

      }
      
    }
  }
  .md-dialog-actions{
    padding: 20px 20px 20px 24px;
  }
}
</style>